import type { PrimaryPageAction } from "@octopusdeploy/design-system-components";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { links } from "@octopusdeploy/portal-routes";
import { OctoLink } from "@octopusdeploy/utilities";
import { PortalEmptyStateOnboarding } from "~/components/GettingStarted/PortalEmptyStateOnboarding";
export function WelcomeAddLicense() {
    const addLicenseKeyPageAction: PrimaryPageAction = {
        type: "navigate",
        label: "Add License Key",
        path: links.licensePage.generateUrl(),
    };
    return (<PortalEmptyStateOnboarding title={"Welcome to Octopus"} primaryAction={addLicenseKeyPageAction} description={<>
                    To start using Octopus, add your license key. You can find it in your <ExternalLink href={OctoLink.Create("ControlCenter")}>Control Center</ExternalLink> subscription.
                </>}/>);
}
